export const DOCUMENT_TYPES_ACTIONS = {
    FIND: 'FIND_DOCUMENT_TYPES',
    GET: 'GET_DOCUMENT_TYPES',
    CHANGE_STATUS: 'CHANGE_STATUS_DOCUMENT_TYPES',
    SUCCESS: 'SUCCESS_DOCUMENT_TYPES',
    ERROR: 'ERROR_DOCUMENT_TYPES',
    CLEAN: 'CLEAN_DOCUMENT_TYPES',
}